import { render, staticRenderFns } from "./RichContent.vue?vue&type=template&id=4fb0f6bc&scoped=true"
import script from "./RichContent.vue?vue&type=script&lang=js"
export * from "./RichContent.vue?vue&type=script&lang=js"
import style0 from "./RichContent.vue?vue&type=style&index=0&id=4fb0f6bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb0f6bc",
  null
  
)

export default component.exports